<template>
	<v-dialog
		persistent
		max-width="600"
		v-model="dialog"
	>
		<v-card v-if="e">
			<v-card-title>
				<span>Bendrieji nustatymai</span>
			</v-card-title>
			<v-card-text>
				<v-form ref="form">
					<CommonSettingsFields
						:key="getKey('numberFields')"
						:values="e.settings"
						ref="numberFields"
					/>
					<v-text-field
						:label="getAttributeTitle('AdminEmail')"
						hide-details
						v-model="adminEmail"
						filled
						class="mt-2"
						:rules="rules"
						:key="getKey('adminEmail')"
					></v-text-field>
				</v-form>
			</v-card-text>
			<v-card-actions class="mx-4 pb-5">
				<v-btn
					color="blue darken-1"
					text
					v-on:click="save"
					outlined
					small
					:loading="saveInAction"
				>
					Išsaugoti
				</v-btn>
				<v-btn
					color="blue darken-1"
					text
					v-on:click="closeDialog"
					outlined
					small
					:disabled="saveInAction"
				>
					Atšaukti
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import AdminHelper from "../helpers/AdminHelper";
	import CommonSettingsFields from "./CommonSettingsFields";

	export default {
		data: function(){
			var data = {
				dialog: false,
				saveInAction: false,
				e: null,
				adminEmail: null,
				settings: null,
				rules: [v => !!v || "Laukas privalomas"],
				iteration: 0
			};
			return data;
		},
		components: {
			CommonSettingsFields
		},
		created: function(){
			this.$vBus.$on("show-admin-settings-editing-form", this.showForm);
		},
		beforeDestroy: function(){
			this.$vBus.$off("show-admin-settings-editing-form", this.showForm);
		},
		methods: {
			closeDialog: function(){
				this.e = null;
				this.dialog = false;
			},
			showForm: function(e){
				this.iteration += 1;
				if (e.settings) {
					this.e = e;
					this.adminEmail = this.e.settings["AdminEmail"];
					this.dialog = true;
				}
			},
			save: function(){
				var formValid = this.$refs.form.validate();
				if (formValid) {
					if (this.$refs.numberFields) {
						this.saveInAction = true;
						var params = {
							MaxInteractiveAtlas: parseInt(this.$refs.numberFields.maxInteractiveAtlases),
							MaxPrintAtlas: parseInt(this.$refs.numberFields.maxPrintableAtlases),
							MaxMb: parseInt(this.$refs.numberFields.maxMb),
							AdminEmail: this.adminEmail
						};
						var def = AdminHelper.updateCommonSettings(params);
						def.then(function(){
							this.saveInAction = false;
							this.dialog = false;
							if (this.e.callback) {
								this.e.callback();
							}
						}.bind(this), function(){
							this.$vBus.$emit("show-message", "error");
							this.saveInAction = false;
						}.bind(this));
					}
				}
			},
			getKey: function(key){
				key = key + "-" + this.iteration;
				return key;
			},
			getAttributeTitle: function(key){
				return AdminHelper.getAttributeTitle(key);
			}
		}
	}
</script>